// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__dtdCk","summary":"CartItem_summary__ue4Uc","price":"CartItem_price__pP54w","amount":"CartItem_amount__b0-du","actions":"CartItem_actions__JbqCw"};